import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { SUPPLY_TYPE } from "../../../shared/constants/pricelist.constants";
import { SUPPLY_TYPE_FILTER_QUERY_PARAM } from "./supply-type-filter.constants";

@Component({
    selector: "vsf-supply-type-filter",
    templateUrl: "./supply-type-filter.component.html",
})
export class SupplyTypeFilterComponent implements OnInit, OnDestroy {
    @Input() loading = false;
    @Output() filterChange = new EventEmitter<string[]>();

    readonly STOCK = SUPPLY_TYPE.STOCK;
    readonly PRE_ORDER = SUPPLY_TYPE.PRE_ORDER;

    stockSelected = false;
    preOrderSelected = false;

    private readonly destroy$ = new Subject<void>();

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.route.queryParams
            .pipe(takeUntil(this.destroy$))
            .subscribe((params: Params) => {
                const param = params[SUPPLY_TYPE_FILTER_QUERY_PARAM];
                const selected = param
                    ? String(param)
                          .split(",")
                          .map((v) => v.trim().toLowerCase())
                    : [];
                this.stockSelected = selected.includes(this.STOCK);
                this.preOrderSelected = selected.includes(this.PRE_ORDER);
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onFilterChange(): void {
        const selected: string[] = [];
        if (this.stockSelected) {
            selected.push(this.STOCK);
        }
        if (this.preOrderSelected) {
            selected.push(this.PRE_ORDER);
        }
        this.filterChange.emit(selected);
    }

    clearFilters(): void {
        this.stockSelected = false;
        this.preOrderSelected = false;
        this.onFilterChange();
    }

    hasActiveFilters(): boolean {
        return this.stockSelected || this.preOrderSelected;
    }
}
